module.exports = __webpack_public_path__ + "static/media/carousel-2.580d0f40.jpg";